import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SessionService {
  private _token: string | null = null;
  private _tipo: string | null = null;
  private _guardiao: any | null = null;
  private _matricula: any | null = null;
  private _orgao: any | null = null;
  private _beneficiario: any | null = null;

  setSession(token: string, tipo: string, guardiao: any): void {
    const incoming = this.parse(guardiao);
    const current = this.guardiao;
    if (JSON.stringify(current) !== JSON.stringify(incoming)) {
      this._beneficiario = null;this._matricula = null;this._orgao = null;
      sessionStorage.removeItem('militarBeneficiario');
    }
    this._guardiao = incoming;
    this._token = token;
    this._tipo = tipo;
    sessionStorage.setItem('token', token);
    sessionStorage.setItem('tipoBeneficiario', tipo);
    sessionStorage.setItem('guardiao', JSON.stringify(this._guardiao));
  }

  private parse(value: any): any {
    try {
      let parsed = value;
      for (let i = 0; i < 2 && typeof parsed === 'string'; i++) parsed = JSON.parse(parsed);
      return parsed && typeof parsed === 'object' ? parsed : null;
    } catch { return null; }
  }

  get guardiao(): any {
    return this._guardiao ?? this.parse(sessionStorage.getItem('guardiao'));
  }

  get token(): string | null {
    return this._token || sessionStorage.getItem('token');
  }

  get tipoBeneficiario(): string | null {
    return this._tipo || sessionStorage.getItem('tipoBeneficiario');
  }

  get isAuthenticated(): boolean {
    return !!this.token && !!this.tipoBeneficiario;
  }

  set orgao(orgao: any) {
    this._orgao = orgao
  }

  set matricula(matricula: any) {
    this._matricula = matricula
  }

  get orgao(): any {
    return this._orgao
  }

  get matricula(): any {
    return this._matricula
  }

  get beneficiario(): any {
    return this._beneficiario ?? this.parse(sessionStorage.getItem('militarBeneficiario'));
  }

  set beneficiario(beneficiario: any) {
    this._beneficiario = beneficiario;
    sessionStorage.setItem('militarBeneficiario', JSON.stringify(beneficiario));
  }
}
